// Testimonial.tsx
import React from 'react';
import { Carousel } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Testimonial.css';

interface TestimonialItem {
  id: number;
  name: string;
  role: string;
  content: string;
  image: string;
  rating: number;
}

const Testimonial: React.FC = () => {
  const testimonials: TestimonialItem[] = [
    {
      id: 1,
      name: "Sachin Pandey",
      role: "Father of Samriddhi Pandey (Class 1)",
      content: "As a proud parent, I am extremely happy to see my daughter performing exceptionally well in all areas — academic, co-curricular and moral development. The school’s balanced approach, supportive teachers and inspiring environment have played a major role in shaping her into a confident, responsible and value-driven student. \n\nThe clarity, presentation and essence of the prospectus truly capture what the school stands for — Excellence in Education with Strong Values. My sincere compliments to the management and the entire teaching team for maintaining such high standards and nurturing young minds with dedication and care.\n\nKeep up the outstanding work  you are truly setting a benchmark in quality education.",
      image: "/images/testimonials/parent1.jpg",
      rating: 5
    },
    {
      id: 2,
      name: "Rishi Devgan",
      role: "Parent of Adrija R Srivastava (Nursery)",
      content: "Being part of ABC Montessori School Lucknow, it has been an amazing journey for our family! Every day, my child walks into school with a big smile and endless curiosity — and that says it all. The creative classrooms, caring teachers, and hands-on learning approach make education feel like an adventure. It’s wonderful to see my child not just learning but loving to learn. ABC Montessori truly builds confident, happy, and independent little explorers!",
      image: "/images/testimonials/parent2.jpg",
      rating: 5
    },
    {
      id: 3,
      name: "Neha Patel",
      role: "Parent of Vihaan (UKG)",
      content: "🙏🙏🙏🙏🙏🙏🙏🙏🙏 \n\n Dear all, \n\n Today I would like to share my experience of admitting my child to this ABC family. \n\nThe activities are well-balanced between learning and playing, helping the child develop confidence, creativity, and social skills. I’ve noticed that the celebrations have made my child explore more about the festivals. The word मां ( celebrated as a part of mother's day celebration in PG) has left a lovely impression on her mind due to which she is being now more connected to her mother. \n\nThanks to Principal ma'am 🙏and all staff members of ABC family for supporting and encouraging my child throughout.",
      image: "/images/testimonials/parent3.jpg",
      rating: 5
    },
    {
      id: 4,
      name: "Ritnesh Kumar",
      role: "Parent of Satvik Chaturvedi (UKG)",
      content: "Thank you for your hard work in supporting my child as they develop. Your patience and commitment mean a lot to our family.With your guidance, our child has grown into a confident and capable learner. We truly appreciate your important role in their development.Thank you for creating such a warm and welcoming classroom environment. It's clear our child feels safe and motivated to learn with you.We appreciate your regular communication and updates on our child’s progress. It helps us stay aligned and support their learning at home.We are so grateful for the individualized attention you give to each student. Our child feels seen and supported, which has made a big difference in their growth.",
      image: "/images/testimonials/parent4.jpg",
      rating: 5
    },
    {
      id: 5,
      name: "Rachna Agarwal",
      role: "Parent of Anand Rawat (Class 1st)",
      content: "He couldn’t have achieved this milestone without you two! Thank you for the support, love, and kindness you’ve showered on him. We’re grateful to New ABC Montessori School for nurturing his potential and guiding him to success. Thank you so much 🙏🏻.",
      image: "/images/testimonials/parent5.jpg",
      rating: 5
    },
    {
      id: 6,
      name: "Soni Singh",
      role: "Mother of Naisha Suryavanshi(UKG)",
      content: "We are very happy with the school’s environment and teaching methods. The teachers are dedicated, supportive, and always approachable. Our child has shown great improvement not only academically but also in confidence and social skills. The extracurricular activities and focus on overall development are really commendable. \n \nThank you for your continuous efforts. \n \n Keep up the good work!",
      image: "/images/testimonials/parent6.jpg",
      rating: 5
    },
    {
      id: 7,
      name: "Bhoomika Dubey",
      role: "Mother of Atharv Dubey (Nursury)",
      content: "Your commitment to our child's development is invaluable. My child is very happy,the teaching staff is excellent at nurturing and developing children's academic skill,social interaction and productive play. My child's confidence has flourished in your school.",
      image: "/images/testimonials/parent7.jpg",
      rating: 5
    },
    {
      id: 8,
      name: "Arpita Rai",
      role: "Mother of Shrija (Nursury)",
      content: "Everything about school is amazing and I absolutely love this school .I am thankful to all the teaching n non teaching staff of the school for creating positive and supportive classroom environment where my daughter Shrija feels comfortable🥰🥰🥰🥰",
      image: "/images/testimonials/parent8.jpg",
      rating: 5
    }
  ];

  const renderWithLineBreaks = (text: string) => {
    return text.split('\n').map((line, i) => (
      <React.Fragment key={i}>
        {line}
        <br />
      </React.Fragment>
    ));
  };

  // Function to render star ratings
  const renderStars = (rating: number) => {
    return Array(5).fill(0).map((_, i) => (
      <span key={i} className={`star ${i < rating ? 'filled' : ''}`}>★</span>
    ));
  };

  return (
    <section className="testimonial-section" id="testimonials">
      <div className="container">
        <div className="section-header text-center mb-5">
          <h2>What Parents Say</h2>
          <p className="text-muted">Hear from our parents about their experience with us</p>
        </div>
        
        <Carousel 
          controls={false} 
          indicators={true}
          interval={5000} // Change slide every 5 seconds
          pause={false}
          className="testimonial-carousel"
        >
          {testimonials.map((testimonial) => (
            <Carousel.Item key={testimonial.id} className="testimonial-item">
              <div className="testimonial-content text-center p-4">
                <div className="testimonial-rating mb-3">
                  {renderStars(testimonial.rating)}
                </div>
                <p className="testimonial-text mb-4">{renderWithLineBreaks(testimonial.content)}</p>
                <div className="testimonial-author">
                  {/* <img 
                    src={testimonial.image} 
                    alt={testimonial.name} 
                    className="testimonial-img"
                  /> */}
                  <h5 className="mb-0">{testimonial.name}</h5>
                  <p className="text-muted mb-0">{testimonial.role}</p>
                </div>
              </div>
            </Carousel.Item>
          ))}
        </Carousel>
      </div>
    </section>
  );
};

export default Testimonial;